module.exports = __webpack_public_path__ + "img/box-arrow-in-down.e2e95330.svg";